import React from 'react'
import {Outlet, Route, Routes, useNavigate, useParams} from 'react-router-dom'
import ParkingReportGraph from './ParkingReportGraph'
import ParkingReportPage from './ParkingReportPage'
import GeoMapParking from './GeoMapParking'
import { useAuth } from '../../../modules/auth'

const ParkingReportData: React.FC = () => {
  const navigate = useNavigate()
  const params = useParams()
  const {currentUser} = useAuth()

  const handleRedirect = (path: string) => {
    navigate(`/reports/parking/${params.id}/${path}`)
  }
  return (
    <section>
      <div className='flex flex-col px-8 py-6'>
        <div className='flex gap-4 items-center w-full justify-center'>
          <button className='btn btn-primary' onClick={() => handleRedirect('')}>
            Report
          </button>
          <button className='btn btn-success' onClick={() => handleRedirect('map')}>
            Maps
          </button>
          {currentUser?.profileType === 'admin' && <button className='btn btn-danger' onClick={() => handleRedirect('graph')}>
            Graph
          </button>}
        </div>
      </div>
      <Outlet />
      <Routes>
        <Route index element={<ParkingReportPage />} />
        <Route path='/map' element={<GeoMapParking />} />
        <Route path='/graph' element={<ParkingReportGraph />} />
      </Routes>
    </section>
  )
}

export default ParkingReportData
